import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RechercheBienComponent } from './recherche-bien/recherche-bien.component';
import { NgbCarouselModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { EstimerBienComponent } from './components/estimer-bien/estimer-bien.component';
import { AcheterBienComponent } from './components/acheter-bien/acheter-bien.component';
import { LouerBienComponent } from './components/louer-bien/louer-bien.component';
import { ListeBiensComponent } from './components/liste-biens/liste-biens.component';
import { SliderBiensComponent } from './components/slider-biens/slider-biens.component';
import { CardBienComponent } from './components/card-bien/card-bien.component';
import { PaginationComponent } from './components/pagination/pagination.component';
import { SujetContactComponent } from './components/sujet-contact/sujet-contact.component';
import { ChoixSujetContactComponent } from './components/choix-sujet-contact/choix-sujet-contact.component';
import { ReactiveFormsModule, FormsModule } from '@angular/forms';
import { CardInfiComponent } from './components/card-infi/card-infi.component';
import { CardArticleComponent } from './components/card-article/card-article.component';
import { MenuAcheterComponent } from './components/menu-acheter/menu-acheter.component';
import { MenuVendreComponent } from './components/menu-vendre/menu-vendre.component';
import { MenuLocationComponent } from './components/menu-location/menu-location.component';
import { MenuProposNousComponent } from './components/menu-propos-nous/menu-propos-nous.component';
import {RouterLink, RouterLinkActive} from '@angular/router';
import { ModalReservationVisiteComponent } from './components/modal-reservation-visite/modal-reservation-visite.component';
import { ModalEstimationRdvComponent } from './components/modal-estimation-rdv/modal-estimation-rdv.component';
import { ModalEstimationBienComponent } from './components/modal-estimation-bien/modal-estimation-bien.component';
import { ModalAlertComponent } from './components/modal-alert/modal-alert.component';
import { ShareMailComponent } from './components/share-mail/share-mail.component';
import { AppMessageComponent } from './components/app-message/app-message.component';
import { ModalContactComponent } from './components/modal-contact/modal-contact.component';
import { NgxCaptchaModule } from 'ngx-captcha';
import { LoaderComponent } from './components/loader/loader.component';
import { ContentLoaderModule } from '@ngneat/content-loader';
import { PipeModule } from '../core/pipes/pipe.module';
import { CheckboxGroupComponent } from '../modules/biens/components/checkbox-group/checkbox-group.component';
import { CheckboxComponent } from '../modules/biens/components/checkbox/checkbox.component';
import { HomeActusComponent } from '../modules/home/home-actus/home-actus.component';
import { HomeBlocAmiComponent } from '../modules/home/home-bloc-ami/home-bloc-ami.component';
import { HomeTestimonialsComponent } from '../modules/home/home-testimonials/home-testimonials.component';
import { GridBiensComponent } from '../modules/biens/components/grid-biens/grid-biens.component';
import { ModalShareComponent } from '../modules/biens/components/modal-share/modal-share.component';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { ModalAlertBienComponent } from '../modules/biens/components/modal-alert-bien/modal-alert-bien.component';
import { ModalOffresComponent } from '../modules/dashboard/components/modal-offres/modal-offres.component';
import { ModalVisitesComponent } from '../modules/dashboard/components/modal-visites/modal-visites.component';
import { ModalEvaluationComponent } from '../modules/dashboard/components/modal-evaluation/modal-evaluation.component';
import { ModalRgpdComponent } from './components/modal-rgpd/modal-rgpd.component';
import { ModalInfoRgpdComponent } from './components/modal-info-rgpd/modal-info-rgpd.component';
import { ModalDelegationComponent } from '../modules/dashboard/components/modal-delegation/modal-delegation.component';
import { ModalDeleteVisiteComponent } from '../modules/dashboard/components/modal-delete-visite/modal-delete-visite.component';
import { ScrollTopComponent } from './components/scroll-top/scroll-top.component';
import { SitemapItemsComponent } from '../pages/sitemap/sitemap-items/sitemap-items.component';
import { ModalDownloadGuideComponent } from './components/modal-download-guide/modal-download-guide.component';
@NgModule({
  declarations: [
    RechercheBienComponent,
    EstimerBienComponent,
    AcheterBienComponent,
    LouerBienComponent,
    ListeBiensComponent,
    SliderBiensComponent,
    CardBienComponent,
    PaginationComponent,
    SujetContactComponent,
    ChoixSujetContactComponent,
    PaginationComponent,
    CardInfiComponent,
    CardArticleComponent,
    MenuAcheterComponent,
    MenuVendreComponent,
    MenuLocationComponent,
    MenuProposNousComponent,
    ModalReservationVisiteComponent,
    ModalEstimationRdvComponent,
    ModalEstimationBienComponent,
    ModalAlertComponent,
    CheckboxGroupComponent,
    CheckboxComponent,
    HomeBlocAmiComponent,
    HomeActusComponent,
    HomeTestimonialsComponent,
    ShareMailComponent,
    AppMessageComponent,
    ModalContactComponent,
    LoaderComponent,
    GridBiensComponent,
    ModalShareComponent,
    ModalAlertBienComponent,
    ModalOffresComponent,
    ModalVisitesComponent,
    ModalEvaluationComponent,
    ModalRgpdComponent,
    ModalInfoRgpdComponent,
    ModalDelegationComponent,
    ModalDeleteVisiteComponent,
    ScrollTopComponent,
    SitemapItemsComponent,
    ModalDownloadGuideComponent
  ],
  imports: [
    CommonModule,
    NgbModule,
    ReactiveFormsModule,
    FormsModule,
    RouterLink,
    NgbCarouselModule,
    NgxCaptchaModule,
    ContentLoaderModule,
    PipeModule,
    FontAwesomeModule,
    RouterLinkActive
  ],
  exports: [
    RechercheBienComponent,
    CardBienComponent,
    PaginationComponent,
    CardInfiComponent,
    CardArticleComponent,
    MenuAcheterComponent,
    MenuVendreComponent,
    MenuLocationComponent,
    MenuProposNousComponent,
    ModalReservationVisiteComponent,
    ModalEstimationRdvComponent,
    ModalEstimationBienComponent,
    ModalAlertComponent,
    CheckboxGroupComponent,
    CheckboxComponent,
    ReactiveFormsModule,
    FormsModule,
    HomeBlocAmiComponent,
    HomeActusComponent,
    HomeTestimonialsComponent,
    ShareMailComponent,
    AppMessageComponent,
    ModalContactComponent,
    LoaderComponent,
    PipeModule,
    GridBiensComponent,
    ModalShareComponent,
    FontAwesomeModule,
    ModalAlertBienComponent,
    ModalOffresComponent,
    SitemapItemsComponent,
    ModalVisitesComponent,
    ModalEvaluationComponent,
    ModalRgpdComponent,
    ModalInfoRgpdComponent,
    ModalDelegationComponent,
    ModalDeleteVisiteComponent,
    ScrollTopComponent,
    ModalDownloadGuideComponent
  ],
})
export class SharedModule {}
